import { Component } from 'react';
import PropTypes from 'prop-types';
import { Howl } from 'howler';
import commonSoundProps from './commonSoundProps';

export default class SoundPlayer extends Component {
  constructor(props) {
    super(props);

    this.loopSoundInstance = new Howl({
      ...commonSoundProps,
      volume: 1,
    });
  }

  componentDidMount() {
    this.playOrderSoundLoop();
  }

  componentWillUnmount() {
    this.clearSoundLoopInterval();
  }

  playOrderSoundLoop = () => {
    const { isSoundEnabled, loopInterval } = this.props;

    if (!isSoundEnabled) return;

    this.clearSoundLoopInterval();
    this.loopSoundInstance.play();
    this.loopIntervalId = setTimeout(this.playOrderSoundLoop, loopInterval);
  };

  clearSoundLoopInterval() {
    if (this.loopIntervalId) clearInterval(this.loopIntervalId);
  }

  render() {
    return null;
  }
}

SoundPlayer.defaultProps = {
  loopInterval: 1000,
};

SoundPlayer.propTypes = {
  isSoundEnabled: PropTypes.bool.isRequired,
  loopInterval: PropTypes.number,
};



// WEBPACK FOOTER //
// ../ui-components/components/OrderSoundPlayer/SoundPlayer.jsx